import { CostEnum } from "../../../Enum/cost-enum";


export class CostDto {
    id: number
    routeType: CostEnum;
    toKmrange: number;
    fromKmrange: number;
    hrs: number;
    cost: number;
    vehicleType:string;
    criteria:string;
    agreeSlab:string;
    perKmsRate:string;
    extraHrs:string;
    localBattaBefAft:string;
    osbatta:string;
    isActive: boolean;
    createdUser: string | null;
    updatedUser: string | null;
    versionFlag: number;
    constructor(
        id: number,
        routeType: CostEnum,
        toKmrange: number,
        fromKmrange: number,
        hrs: number,
        cost: number,
        vehicleType:string,
        criteria:string,
        agreeSlab:string,
        perKmsRate:string,
        extraHrs:string,
        localBattaBefAft:string,
        osbatta:string,
        isActive: boolean,
        createdUser: string | null,
        updatedUser: string | null,
        versionFlag: number,
    ) {
        this.id = id;
        this.routeType = routeType;
        this.toKmrange = toKmrange;
        this.fromKmrange = fromKmrange;
        this.hrs = hrs;
        this.cost = cost;
        this.vehicleType=vehicleType;
        this.criteria=criteria;
        this.agreeSlab=agreeSlab;
        this.perKmsRate=perKmsRate;
        this.extraHrs=extraHrs;
        this.localBattaBefAft=localBattaBefAft;
        this.osbatta=osbatta;
        this.isActive = isActive;
        this.createdUser = createdUser;
        this.updatedUser = updatedUser;
        this.versionFlag = versionFlag;
    }
}